import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import { GLOBAL_SETTINGS, NOTIFICATION_RECIPIENTS_URL } from 'SharedDir/backend/endpoints/global-settings';
import { GlobalSettings } from 'SharedDir/declarations/global-settings';

export default class GlobalSettingsApiClass {
  // eslint-disable-next-line class-methods-use-this
  async getTmcProvidedPeriodDays(): Promise<GlobalSettings.TmcProvidedPeriodDaysFull> {
    const { data } = (await http(
      GLOBAL_SETTINGS.TMC_PROVIDED_PERIOD_DAYS_GET
    )) as AxiosResponse<GlobalSettings.TmcProvidedPeriodDaysFull>;
    return data;
  }

  // eslint-disable-next-line class-methods-use-this
  async updateTmcProvidedPeriodDays(
    payload: GlobalSettings.TmcProvidedPeriodDaysUpdate
  ): Promise<GlobalSettings.TmcProvidedPeriodDaysFull> {
    const { data } = (await http({
      ...GLOBAL_SETTINGS.TMC_PROVIDED_PERIOD_DAYS_UPDATE,
      data: payload,
    })) as AxiosResponse<GlobalSettings.TmcProvidedPeriodDaysFull>;
    return data;
  }

  // eslint-disable-next-line class-methods-use-this
  async getOrCreateRecipient(
    payload: GlobalSettings.NotificationRecipientCreate
  ): Promise<GlobalSettings.NotificationRecipient> {
    const { data } = (await http({
      method: 'POST',
      url: NOTIFICATION_RECIPIENTS_URL,
      data: payload,
    })) as AxiosResponse<GlobalSettings.NotificationRecipient>;
    return data;
  }
}
